var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSewing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1688 8.34142L2.94658 11.3889C2.64102 11.4791 2.37794 11.6759 2.20511 11.9435C2.03228 12.2112 1.96116 12.5319 2.00466 12.8475C2.04816 13.1631 2.20339 13.4527 2.44218 13.6636C2.68096 13.8745 2.98746 13.9927 3.30602 13.9969H12.6371C12.9578 13.9971 13.2679 13.8816 13.5102 13.6714C13.7525 13.4613 13.9108 13.1707 13.956 12.8532C14.0012 12.5356 13.9303 12.2125 13.7562 11.9431C13.5821 11.6737 13.3166 11.4762 13.0085 11.3869L12.2663 11.1739C11.9892 11.0936 11.7457 10.9253 11.5724 10.6946C11.3992 10.4639 11.3056 10.1831 11.3058 9.89454V5.11719",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99766 7.68144L13.0071 4.63144C13.3127 4.54125 13.5758 4.34446 13.7486 4.07683C13.9214 3.80919 13.9925 3.48845 13.949 3.17285C13.9055 2.85724 13.7503 2.5677 13.5115 2.3568C13.2727 2.1459 12.9662 2.02762 12.6477 2.02344H3.31663C2.99588 2.02321 2.68583 2.13879 2.4435 2.34892C2.20117 2.55905 2.04285 2.84961 1.99766 3.16716C1.95247 3.48471 2.02344 3.80791 2.19753 4.0773C2.37162 4.3467 2.63712 4.54418 2.9452 4.63344L3.6874 4.84645C3.96452 4.9268 4.20803 5.09502 4.38127 5.32576C4.55451 5.5565 4.64809 5.83728 4.64793 6.12582V10.9038",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewing);
export default __webpack_public_path__ + "static/media/sewing.d133d950edc5418a8d03b72deba548d3.svg";
export { ForwardRef as ReactComponent };